// extracted by mini-css-extract-plugin
module.exports = {"container":"PageHeader_container__1fG_y","title":"PageHeader_title__TtE06","actions":"PageHeader_actions__1yIlC"};